const has = Object.prototype.hasOwnProperty;

export default has;
